import React, { useState, useEffect } from 'react';
import './snackbar.css';
import { cn } from '../../utils/cn';
import Close from '../globals/icons/close';
import Error from '../globals/icons/error';
import Success from '../globals/icons/success';
import Warning from '../globals/icons/warning';
import Important from '../globals/icons/important';

function Snackbar({
  message,
  duration = 6000,
  onClose,
  type = 'error',
  className,
}) {
  const [visible, setVisible] = useState(true);

  const styles = {
    success:
      'bg-success text-success-foreground border border-success-foreground',
    error: 'bg-error text-error-foreground border border-error-foreground',
    important:
      'bg-important text-important-foreground border border-important-foreground',
    warning:
      'bg-warning text-warning-foreground border border-warning-foreground',
  };

  const icons = {
    success: <Success />,
    important: <Important />,
    warning: <Warning />,
    error: <Error />,
  };

  // Default icon and style if the type is invalid
  const currentStyle = styles[type] || styles.error;
  const Icon = icons[type] || icons.error;

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timeout);
  }, [duration, onClose]);

  if (!visible) return null;

  return (
    <div
      className={cn(
        `${currentStyle} p-5 fixed top-20 right-5 rounded-2 flex justify-between items-start gap-3 border max-w-80 z-50`,
        className
      )}
    >
      <span className='min-w-6'>{Icon}</span>
      <span className='text-sm'>{message}</span>
      <span
        className='cursor-pointer min-w-6'
        onClick={() => {
          onClose ? onClose() : setVisible(false);
        }}
      >
        <Close />
      </span>
    </div>
  );
}

export default Snackbar;
